import React from 'react'
import './onecol.css'

function OneCol({gallery}) {
  return (
    <div className='colContainer'>
        {gallery.map((item) => {
            return(
                <img src={item.image} alt='' />
            )
        })}
    </div>
  )
}

export default OneCol